import { Sensors } from "gql/api";

export function computeSensorLabel(sensor?: Partial<Sensors> | null): string {
  if (sensor) {
    return `${sensor.manufacturer} / ${sensor.part_number}`;
  }
  return "";
}
